import React, { ReactNode } from 'react';
import { Flex, Icon, IconProps, Text, SystemProps } from '@televet/kibble-ui';

interface props extends IconProps {
  children: ReactNode;
  align?: SystemProps['alignItems'];
  mb?: number;
}

export const IconText = ({ children, size = 'md', align = 'center', mb = 2, ...rest }: props): JSX.Element => {
  return (
    <Flex align={align} mb={mb}>
      <Flex flexGrow={0} flexShrink={0}>
        <Icon {...rest} size={size} color={'active'} />
      </Flex>
      <Text ml={2} size="sm">
        {children}
      </Text>
    </Flex>
  );
};
